import { useState } from 'react';
import clsx from 'clsx';

interface BookmarkThumbnailProps {
  thumbnailUrl?: string;
  showThumbnails: boolean;
  condensedView: boolean;
}

function BookmarkThumbnail({
  thumbnailUrl,
  showThumbnails,
  condensedView,
}: BookmarkThumbnailProps) {
  const [hasError, setHasError] = useState(false);

  if (!showThumbnails) {
    return null;
  }

  const showPlaceholder = !thumbnailUrl || hasError;
  const containerClasses = clsx(
    'ml-2 flex-shrink-0 rounded-xl transition-all overflow-hidden',
    condensedView ? 'h-20 w-20' : 'h-24 w-24',
  );

  return (
    <div
      className={containerClasses}
      style={{ backgroundColor: 'var(--bg-placeholder)' }}
    >
      {showPlaceholder ? (
        <div className="flex h-full w-full items-center justify-center">
          <ThumbnailPlaceholderIcon />
        </div>
      ) : (
        <img
          src={thumbnailUrl}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
}

/** Shared document/thumbnail placeholder icon – exported for reuse (e.g. batch selection stack). */
export function ThumbnailPlaceholderIcon() {
  return (
    <svg
      width="60px"
      height="60px"
      viewBox="0 0 226 226"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'var(--color-icon)', opacity: 0.2 }}
    >
      <path d="M110.423 136.002H92.4229V130.002H110.423V136.002Z" fill="currentColor" />
      <path d="M110.423 124.002H92.4229V118.002H110.423V124.002Z" fill="currentColor" />
      <path d="M110.423 112.002H92.4229V106.002H110.423V112.002Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.425 109.998H117.425V91.998H147.425V109.998ZM123.425 103.998H141.425V97.998H123.425V103.998Z"
        fill="currentColor"
      />
      <path d="M110.423 97.998H92.4229V91.998H110.423V97.998Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.427 141.275C160.426 148.806 153.584 154.001 146.728 154.002H73.4268V153.984C66.678 153.821 60.4249 148.798 60.4248 141.223V132H80.0068V78H160.427V141.275ZM86.0068 141.275C86.0066 143.752 85.4094 146.051 84.2783 148.002H117.425V118.002H147.425V147.961C151.377 147.635 154.426 144.601 154.427 141.275V84H86.0068V141.275ZM123.425 148.002H141.425V124.002H123.425V148.002ZM66.4248 141.223C66.4249 145.022 69.5515 147.909 73.5908 147.99C75.5642 147.952 77.1169 147.25 78.1787 146.18C79.2696 145.08 80.0065 143.431 80.0068 141.275V138H66.4248V141.223Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default BookmarkThumbnail;
